import React from 'react';

interface ConfirmationModalProps {
  show: boolean;
  text: string;
  onConfirmDelete: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  text,
  onConfirmDelete,
  onCancel,
  confirmLabel = 'Yes, Delete',
  cancelLabel = 'Cancel',
}) => {
  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', zIndex: 2000 }} aria-modal="true" role="dialog">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center">
            <span className="delete-icon">
              <i className="ti ti-trash-x" />
            </span>
            <h4>Confirm Deletion</h4>
            <p>{text}</p>
            <div className="d-flex justify-content-center">
              <button type="button" className="btn btn-light me-3" onClick={onCancel}>
                {cancelLabel}
              </button>
              <button type="button" className="btn btn-danger" onClick={onConfirmDelete}>
                {confirmLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal; 